import { DataState } from './types'

const initialDataState: DataState = {
    dealers: [],
    businessUnits: [],
    contactInfo: {
        support: 'support@autralis.com',
    },
}

export default initialDataState
